import { createContext, useContext } from "react";
import type { FlatNavItem } from "./navConfig";

/**
 * What the shell knows about the current screen — read by ScreenHeader (title),
 * the related-settings panel, the help center, automations and the palette.
 */
export type ShellContextValue = {
  nav: FlatNavItem[];
  current: FlatNavItem | null;
  /** the user has this menu item (permission-aware, from GET /navigation) */
  can: (navKey: string) => boolean;
  /** the user has this permission key (GET /permissions/granted) */
  allowed: (permissionKey: string) => boolean;
};

export const ShellContext = createContext<ShellContextValue>({
  nav: [],
  current: null,
  can: () => false,
  allowed: () => false,
});

export function useShell(): ShellContextValue {
  return useContext(ShellContext);
}
